var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2873 14.6112H5.71587C5.08729 14.6112 4.57301 14.1175 4.57301 13.514V8.02831H2.75587C1.73872 8.02831 1.23586 6.8434 1.95587 6.15219L7.20158 1.11631C7.4151 0.910866 7.70499 0.79541 8.00729 0.79541C8.3096 0.79541 8.59949 0.910866 8.81301 1.11631L14.0587 6.15219C14.7787 6.8434 14.2644 8.02831 13.2473 8.02831H11.4302V13.514C11.4302 14.1175 10.9159 14.6112 10.2873 14.6112ZM14.8571 16.8056H1.14286C0.514286 16.8056 0 17.2993 0 17.9027C0 18.5061 0.514286 18.9998 1.14286 18.9998H14.8571C15.4857 18.9998 16 18.5061 16 17.9027C16 17.2993 15.4857 16.8056 14.8571 16.8056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0f2b1a42.svg";
export { ForwardRef as ReactComponent };